import { render, staticRenderFns } from "./GroupNotFound.vue?vue&type=template&id=8a120a9e&"
import script from "./GroupNotFound.vue?vue&type=script&lang=ts&"
export * from "./GroupNotFound.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports